import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "../assets/css/adminLayout.module.css";

const BaseURL = process.env.REACT_APP_BASEURL;

const SearchData = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchHistory = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${BaseURL}/product/user-searched-history/`, {
                headers: {
                    accept: "application/json",
                    Authorization: `Token ${localStorage.getItem("adminAuth")}`,
                },
            });
            console.log("User Search History Response:", response.data);

            if (response.data) {
                // Adjust this based on actual response structure. 
                // Assuming response might be an array or paginated object.
                const fetchedData = response.data.results || response.data;
                if (Array.isArray(fetchedData)) {
                    setData(fetchedData);
                } else {
                    setData([]);
                }
            } else {
                setData([]);
            }

        } catch (error) {
            console.error("Error fetching User Search History:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchHistory();
    }, []);

    return (
        <div className={styles.container} style={{ padding: "20px" }}>
            <h2 style={{ marginBottom: "20px" }}>User Search History</h2>

            {loading ? (
                <p>Loading...</p>
            ) : (
                <div style={{ overflowX: "auto" }}>
                    {/* Simple table to verify functionality - columns will need adjustment based on logged data */}
                    <table style={{ width: "100%", borderCollapse: "collapse", backgroundColor: "#fff" }}>
                        <thead>
                            <tr style={{ backgroundColor: "#019c89", color: "white", textAlign: "left" }}>
                                <th style={thStyle}>ID</th>
                                <th style={thStyle}>Search Query</th>
                                <th style={thStyle}>User</th>
                                <th style={thStyle}>Created At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 ? (
                                data.map((item, index) => (
                                    <tr key={item.id || index} style={{ borderBottom: "1px solid #ddd" }}>
                                        <td style={tdStyle}>{item.id}</td>
                                        <td style={tdStyle}>{item.search_query || item.query}</td>
                                        <td style={tdStyle}>{item.user_email || item.user}</td>
                                        <td style={tdStyle}>{item.created_at || item.timestamp}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{ padding: "20px", textAlign: "center" }}>
                                        No history found or check console for structure
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

const thStyle = {
    padding: "12px",
    borderBottom: "1px solid #ddd",
};

const tdStyle = {
    padding: "12px",
};

export default SearchData;
